export const exportToCSV = ( data, columns ) => {
  const csvData = data.map( ( item ) => {
    const row = {}
    columns.forEach( ( column ) => {
      const value = column.accessor( item )
      row[column.id] = value
    } )
    return row
  } )

  const csvContent = `data:text/csv;charset=utf-8,${ 
    [ 
      columns.map( col => col.id ).join( ',' ), 
      ...csvData.map( e => Object.values( e ).join( ',' ) ) 
    ].join( '\n' )}`

  const encodedUri = encodeURI( csvContent )
  const link = document.createElement( 'a' )
  link.setAttribute( 'href', encodedUri )
  link.setAttribute( 'download', 'exported_data.csv' )
  document.body.appendChild( link )
  link.click()
}
export const exportToJSON = ( data ) => {
  const jsonContent = JSON.stringify( data, null, 2 )
  const blob = new Blob( [ jsonContent ], { type : 'application/json' } )
  const link = document.createElement( 'a' )
  link.href = URL.createObjectURL( blob )
  link.download = 'exported_data.json'
  document.body.appendChild( link )
  link.click()
}
